import React, { useState, useEffect } from "react";
import style from './ModalStyles.module.css';
import { HandleInput } from "../ferramentas/handleInput/handleInput";
import ToastMessage from "../ferramentas/toastMessage/ToastMessage";
import { useDataManagement } from "../ferramentas/RequisitarAPI.ts";
import SearchBar from "./SearchBar.js";
import Placeholder from "../ferramentas/placeholder/Placeholder.js";
import isWhiteOrNearWhite from "../ferramentas/VerificarCores.js";

const ServicoModal = ({ onClose, onSave }) => {
  const [formData, setFormData] = useState({
    id: 0,
    nome: "",
    descricao: "",
    preco: "",
    cor: "#4240BF",
    prazo: "00:00",
    status: { value: true, label: "Ativo" },
  });
  const [services, setServices] = useState({});
  const [isFieldsDisabled, setIsFieldsDisabled] = useState(true);
  const { services: fetchServices } = useDataManagement();
  
  // Efeito para carregar os serviços da API
  useEffect(() => {
    const loadServices = async () => {
      const result = await fetchServices.listAll();
      if (result.ok) {
        setServices(result.data);
      }
    };
    loadServices();
  }, [fetchServices]);

  // Handler para o clique no botão de novo serviço
  const handleNewService = () => {
    setFormData({
      id: 0,
      nome: "",
      descricao: "",
      preco: "",
      cor: "#4240BF",
      prazo: "00:30",
      status: { value: true, label: "Ativo" },
    });
    setIsFieldsDisabled(false); // Libera a exibição do formulário
  };

  // Prepara os dados para o componente SearchBar
  const dataForSearch = (servicesData) => {
    return Object.values(servicesData).map((service) => ({
      options: [
        { value: service.id, label: `TÍTULO: ${service.name}` }
      ]
    }));
  };

  // Handler para quando um serviço é selecionado na busca
  const optionHandle = (selectedOption) => {
    if (selectedOption) {
      const selectedService = Object.values(services).find(
        (service) => service.id === selectedOption.value
      );
      if (selectedService) {
        setFormData({
          id: selectedService.id,
          nome: selectedService.name,
          descricao: selectedService.description,
          preco: selectedService.price,
          cor: selectedService.color,
          prazo: selectedService.time_service,
          status: selectedService.active
            ? { value: true, label: "Ativo" }
            : { value: false, label: "Inativo" }
        });
        setIsFieldsDisabled(false); // Libera a exibição do formulário
      }
    }
  };

  // Handler para submeter o formulário
  const handleSubmit = (e) => {
    e.preventDefault();
    const { id, nome, descricao, preco, cor, prazo, status } = formData;
    const servicoData = { id, nome, descricao, preco, cor, prazo, status: status.value };

    if (!nome || !preco) {
        ToastMessage({ cod: "e", texto: "Nome e Preço são campos obrigatórios." });
        return;
    }
    if (isWhiteOrNearWhite(cor)) {
      ToastMessage({ cod: "e", texto: "Cores muito próximas ao branco não são permitidas." });
      return;
    }
    if (parseFloat(servicoData.preco) < 0) {
      ToastMessage({ cod: "e", texto: "O preço não pode ser negativo." });
      return;
    }
    const serviceExists = Object.values(services).some(
      (service) => service.name.toLowerCase() === nome.toLowerCase() && service.id !== id
    );
    if (serviceExists) {
      ToastMessage({ cod: "e", texto: "Já existe um serviço com este nome." });
      return;
    }

    onSave(servicoData);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (selectedOption, name) => {
    setFormData(prev => ({ ...prev, [name]: selectedOption }));
  };

  return (
    <div className={style.modal} onClick={onClose}>
      <div className={style.modal_content} onClick={(e) => e.stopPropagation()}>

        <div className={style.modalHeader}>
          <h2>Gerenciar Serviço</h2>
          <span className={style.close} onClick={onClose}>×</span>
        </div>

        <div className={style.modalBody}>
          <div className={style.topActionContainer}>
            <div className={style.searchWrapper}>
              <SearchBar
                data={dataForSearch(services)}
                optionHandle={optionHandle}
              />
            </div>
            <button
              className={`${style.modalButton} ${style.newServiceButton}`}
              type="button"
              onClick={handleNewService}
            >
              + <span>Novo Serviço</span>
            </button>
          </div>

          {/* --- RENDERIZAÇÃO CONDICIONAL AQUI --- */}
          {isFieldsDisabled ? (
            <div className={style.promptContainer}>
              <p>Busque um serviço para editar ou crie um novo.</p>
            </div>
          ) : (
            <div className={style.formFieldsContainer}>
              <form id="servicoForm" className={style.modalForm} onSubmit={handleSubmit}>
                <div className={style.fullWidth}>
                  <Placeholder
                    label="Nome do Serviço" type="text" name="nome" required
                    value={formData.nome} onChange={handleInputChange}
                  />
                </div>
                <Placeholder
                  label="Preço (R$)" type="number" name="preco" required
                  step="0.01" min={0} onKeyDown={HandleInput}
                  value={formData.preco} onChange={handleInputChange}
                />
                <Placeholder
                  label="Tempo Estimado" type="time" name="prazo" required
                  value={formData.prazo} onChange={handleInputChange}
                />
                <div className={style.fullWidth}>
                  <Placeholder
                    label="Descrição (Opcional)" type="textarea" name="descricao"
                    value={formData.descricao} onChange={handleInputChange}
                  />
                </div>
                <Placeholder
                  label="Cor na Agenda" type="color" name="cor"
                  value={formData.cor} onChange={handleInputChange}
                />
                <div className={`${style.select}`}>
                  <Placeholder
                    label="Status" type="select" name="status"
                    value={formData.status}
                    onChange={(option) => handleSelectChange(option, 'status')}
                    options={[{ value: true, label: "Ativo" }, { value: false, label: "Inativo" }]}
                    required
                  />
                </div>
              </form>
            </div>
          )}
        </div>

        <div className={style.modalFooter}>
          <button
            className={`${style.modalButton} ${style.cancelButton}`}
            type="button"
            onClick={onClose}
          >
            Cancelar
          </button>
          <button
            className={`${style.modalButton} ${style.saveButton}`}
            type="submit"
            form="servicoForm"
            disabled={isFieldsDisabled}
          >
            Salvar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServicoModal;